<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-01-30 13:51:11
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-31 17:12:03
 * @Description: file content
 -->
<template>
  <div class="index_module-title">
    <div class="label_bar">
      <span class="text_bar">{{name}}</span>
      <span class="text_bar2" v-if="secname">{{secname}}</span>
      <span class="more" v-if="showMore">
        <span @click="tapMore">更多</span>
        <img src="http://assets.wxmp.ruthus.com/rushixcx/icon_right.png" />
      </span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    secName: String,
    initName: String,
    initShowMore: Boolean
  },
  data() {
    return {
      secname: this.secName,
      name: this.initName,
      showMore: this.initShowMore
    };
  },
  watch: {},
  computed: {},
  methods: {
    tapMore() {
      this.$emit("tapMy", this.name);
    }
  },
  created() {},
  mounted() {
    console.log(this.initShowMore)
  }
};
</script>
<style lang="css" scoped>
/* 通用模块标题 */

.label_bar {
  position: relative;
  width: 100%;
  height: 0.75rem;
  margin-top: 0.3rem;
}

.label_bar .text_bar {
  position: absolute;
  font-size: 0.4rem;
  font-weight: 600;
  line-height: 0.5rem;
  height: 0.5rem;
  top: 0.125rem;
  left: 0.4rem;
  color: #333333;
}

.label_bar .text_bar2 {
  position: absolute;
  font-size: 0.24rem;
  line-height: 0.5rem;
  height: 0.5rem;
  top: 0.165rem;
  left: 2.2rem;
  color: #9c9c9c;
}

.label_bar .more {
  font-size: 0.25rem;
  float: right;
  background: #fff;
  margin-right: 0.1rem;
  margin-top: 0.05rem;
  vertical-align: middle;
/*  border-radius: 0.2rem;
  -webkit-box-shadow: 0 0 0.25rem #cbcbcb;
  box-shadow: 0 0 0.25rem #cbcbcb;*/
  height: 0.4rem;
  line-height: 0.4rem;
  width: 1rem;
  text-align: center;
  margin-top: 0.25rem;
}
.label_bar .more > img {
  width: 5px;
  height: 10px;
  vertical-align: initial;
  padding-left: 3px;
  padding-top: 5px;
}
/* .label_bar > img {
  vertical-align: middle;
  float: right;
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.25rem;
  padding-top: 0.09rem;
} */
</style>